'use client';

import { useMsal } from '@azure/msal-react';
import { microsoftClarityProjectId, useClarity } from '@common';

export interface IClarityProviderProps {
  children: React.ReactNode;
}

export const ClarityProvider = ({ children }: IClarityProviderProps) => {
  const { accounts } = useMsal();
  useClarity(microsoftClarityProjectId, accounts?.[0]?.username);

  return <>{children}</>;
};
